module.exports = window["wp"]["warning"];